var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcesando(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30 0C32.7618 0 35 2.2382 35 5L35 30C35 32.7618 32.7618 35 30 35L5 35C2.2382 35 0 32.7618 0 30L0 5C0 2.2382 2.2382 0 5 0L30 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Procesando"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo-6"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "none",
    fill: "#FFFFFF",
    xlinkHref: "#path_1"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1",
    fill: "none",
    stroke: "#C6C6C6",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7 17.2998C7 15.9191 8.11929 14.7998 9.5 14.7998C10.8807 14.7998 12 15.9191 12 17.2998C12 18.6805 10.8807 19.7998 9.5 19.7998C8.11929 19.7998 7 18.6805 7 17.2998Z",
    id: "Oval",
    fill: "#C6C6C6",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17.2998C15 15.9191 16.1193 14.7998 17.5 14.7998C18.8807 14.7998 20 15.9191 20 17.2998C20 18.6805 18.8807 19.7998 17.5 19.7998C16.1193 19.7998 15 18.6805 15 17.2998Z",
    id: "Oval-2",
    fill: "#C6C6C6",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 17.2998C23 15.9191 24.1193 14.7998 25.5 14.7998C26.8807 14.7998 28 15.9191 28 17.2998C28 18.6805 26.8807 19.7998 25.5 19.7998C24.1193 19.7998 23 18.6805 23 17.2998Z",
    id: "Oval-2-Copy",
    fill: "#C6C6C6",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcesando);
export default __webpack_public_path__ + "static/media/Procesando.1a99a9f0dbaa9cdd33759362c1666ad8.svg";
export { ForwardRef as ReactComponent };